module.exports = __webpack_public_path__ + "img/place.950a994b.png";